import React from 'react';
import { Box, Stack } from '@mui/material';
import { PersonOutline, HomeOutlined, LanguageOutlined } from '@mui/icons-material';
import { SectionHeader, SectionPaper } from '../../../../common/components/styled-ui-elements';
import {
  PrimaryContactNameEdit, PrimaryPhoneEdit, PrimaryEmailEdit,
  SecondaryContactNameEdit, SecondaryPhoneEdit, SecondaryEmailEdit,
  WebsiteEdit,
  StreetEdit, CityEdit, StateEdit, ZipEdit,
} from '../fields';

export const VendorContactSection: React.FC = () => {
  return (
    <Box>
      {/* Primary Contact */}
      <SectionHeader
        icon={<PersonOutline sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
        title="Primary Contact"
      />
      <SectionPaper>
        <Stack spacing={2}>
          <Stack direction="row" gap={2}>
            <PrimaryContactNameEdit />
            <PrimaryPhoneEdit />
            <PrimaryEmailEdit />
          </Stack>
        </Stack>
      </SectionPaper>

      {/* Secondary Contact */}
      <Box mt={2}>
        <SectionHeader
          icon={<PersonOutline sx={{ mr: 1, color: '#64748b', fontSize: 18 }} />}
          title="Secondary Contact"
        />
        <SectionPaper>
          <Stack spacing={2}>
            <Stack direction="row" gap={2}>
              <SecondaryContactNameEdit />
              <SecondaryPhoneEdit />
              <SecondaryEmailEdit />
            </Stack>
          </Stack>
        </SectionPaper>
      </Box>

      {/* Website */}
      <Box mt={2}>
        <SectionHeader
          icon={<LanguageOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
          title="Website"
        />
        <SectionPaper>
          <WebsiteEdit />
        </SectionPaper>
      </Box>

      {/* Address */}
      <Box mt={2}>
        <SectionHeader
          icon={<HomeOutlined sx={{ mr: 1, color: '#3b82f6', fontSize: 18 }} />}
          title="Address"
        />
        <SectionPaper>
          <Stack spacing={2}>
            <StreetEdit />
            <Stack direction="row" gap={2}>
              <CityEdit />
              <StateEdit />
              <ZipEdit />
            </Stack>
          </Stack>
        </SectionPaper>
      </Box>
    </Box>
  );
};

export default VendorContactSection;
